// export function Hero() {
//   return (
//     <section
//       id="home"
//       className="flex flex-col items-center justify-center text-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20"
//       style={{ minHeight: "calc(100vh - 80px)" }}
//     >
//       <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">
//         Your One-Stop Tech Destination
//       </h2>
//       <p className="text-base sm:text-lg md:text-xl max-w-xl md:max-w-2xl mb-4 sm:mb-6">
//         We sell, repair, and upgrade computers and accessories with trusted
//         expertise and outstanding service.
//       </p>
//       <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
//         <a
//           href="#products"
//           className="bg-white text-blue-600 px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg font-medium sm:font-semibold shadow-md hover:bg-gray-100"
//         >
//           Shop Now
//         </a>
//         <a
//           href="#contact"
//           className="bg-blue-900 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg font-medium sm:font-semibold shadow-md hover:bg-blue-800"
//         >
//           Request Repair
//         </a>
//       </div>
//     </section>
//   );
// }

import React from "react";

export function Hero() {
  return (
    <section className="relative flex flex-col lg:flex-row items-center justify-between bg-blue-600 px-6 lg:px-20 py-16 lg:py-24 text-white overflow-hidden">
      {/* Left Column */}
      <div className="lg:w-1/2 text-center lg:text-left space-y-6">
        <h1 className="text-4xl sm:text-5xl font-bold leading-tight">
          Tech & Print Solutions <br />
          <span className="text-blue-200">for Ugandan Businesses</span>
        </h1>

        <p className="text-lg sm:text-xl max-w-md text-blue-100">
          KEVMARK delivers ICT, stationery, branding, and printing services —
          smart, reliable, and trusted since 2008.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-6">
          <a
            href="#products"
            className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-gray-100 transition"
          >
            Explore Products
          </a>
          <a
            href="#services"
            className="border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white hover:text-blue-600 transition"
          >
            Our Services
          </a>
        </div>
      </div>

      {/* Right Column */}
      <div className="lg:w-1/2 mt-10 lg:mt-0 flex justify-center lg:justify-end">
        <img
          src="/images/hero.png"
          alt="Kevmark team at work"
          className="w-80 sm:w-96 lg:w-[400px]"
        />
      </div>
    </section>
  );
}

// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export function Hero() {
//   const { pathname } = useLocation();

//   // Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return (
//     <section
//       id="home"
//       className="flex flex-col items-center justify-center text-center bg-gradient-to-r from-blue-600 to-indigo-700 bg-cover bg-center text-white px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16"
//       style={{
//         minHeight: "calc(100vh - 80px)",
//         backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
//       }}
//     >
//       <h2 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3">
//         Your One-Stop Tech Destination
//       </h2>
//       <p className="text-sm sm:text-base md:text-lg max-w-md sm:max-w-lg md:max-w-xl mb-3 sm:mb-4">
//         We sell, repair, and upgrade computers and accessories with trusted
//         expertise and outstanding service.
//       </p>
//       <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
//         <a
//           href="#products"
//           className="bg-white text-blue-600 px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg font-medium shadow-md hover:bg-gray-100"
//         >
//           Shop Now
//         </a>
//         <a
//           href="#contact"
//           className="bg-blue-900 text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg font-medium shadow-md hover:bg-blue-800"
//         >
//           Request Repair
//         </a>
//       </div>
//     </section>
//   );
// }
